import { http } from '@/server/http'
import { apiGroup } from '@/server/api-group'
export interface RequestWithAbortOptions {
  method: 'get' | 'post'
  url: string
  data?: any
}

export const RequestWithAbort = async ({ method, url, data }: RequestWithAbortOptions) => {
  const controller = new AbortController()
  const res = await http(method, apiGroup[url], data, controller.signal)

  return {
    res,
    abort: () => controller.abort()
  }
}
